import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { Router } from '~i18n';
import { unifiedNavigate } from '~utils/unifiedNavigate';
const Index: NextPage = () => {
  useEffect(() => {
    unifiedNavigate('/my-bookings');
  }, []);
  return <div></div>;
};

export default Index;
